import React from 'react';
import { Text} from 'react-konva';
import {
  exitMobileFlipCardScale,
  fontFamily,
  fullNameFontSize,
  fullNameLargeFontSize,
  fullNameFontColor,
  fullNameFontStyle,
  fullNameFontWeight,
  fullNameLineHeight,
  fullNameLargeFontLineHeight,
  isDevelopment,
  fullNameLineWidthPedigreeTreeNormalFont,
  fullNameLineWidthPedigreeTreeLargeFont,
  // cachetree,
  dualPedigreeMode,
  spanOutDualPedigreeProfilessBy,
  fontArray,
 } from '../../library/constants';
import {
  isAndroidPhone,
  isMobileTablet,
  isMobilePhone,
  urlGet,
  truncateWord,
  getWidthKonvaText,
  widenGreatGrandParentsForDualPedigree,
  shiftForUnionRoot,
  capitalizeFirstLetter,
  buildNameLineArray,
  getPropFromObjInArray,
} from '../../library/calc';

import { cloneDeep } from 'lodash';

class EachLineFullName extends  React.Component {

  constructor(props){
    super(props);

    this.props.buildRefObj({key: this.props.refName, objClass: this})
    this.state = {
      hovering: false,
    }
  }

  componentDidUpdate(){
  }

  isPedigreeGhost(){
    return typeof(this.props.nodeObj.isPedigreeGhost) !== 'undefined' && this.props.n < 0
  }

  getOtherIdxArray(){
    let idxArrays = [];
    for( let i = 0; i <= this.props.idxRows; i++){
      idxArrays.push(i);
    }
    return idxArrays;
  }

  callHoverForEveryLineInFullName(hovering){

    const idxArrays = this.getOtherIdxArray();
    idxArrays.forEach((idx)=>{
      this.props.callRefObj({key: `fullname_n-${this.props.n}-${idx}`, method: 'callHover', param: hovering})
    })

  }

  hovering(hovering){

    this.callHoverForEveryLineInFullName(hovering);

  }

  callHover(hovering){
    this.setState({hovering});
  }

  isHyperLinkActive(){

    const { scaleX } = this.props;
    const scaleToAllowHyperlink = exitMobileFlipCardScale;

    if( scaleX >= scaleToAllowHyperlink) return true;
    else return false;

  }

  onClick(){
    const {
      canShowHyperlinkOut,
      nvp,
      onClickedNode,
      onClickedFullName,
      pr_id,
      n,
      openAddNodeForm,
      pedigreeGhostAddLabel,
      pedigreeGhostMale,
      pedigreeParentNodeId,
      showDualPedigreeModalChangeName,
    } = this.props;
    if( dualPedigreeMode ){
      showDualPedigreeModalChangeName({node:n, whichField: 'profileName'});
      return;
    }
    if(!canShowHyperlinkOut(nvp)) return;
    if(isMobilePhone() ) return;
    if( !this.isHyperLinkActive() ) { onClickedNode(n); return;}

    if(typeof(pedigreeGhostAddLabel) !== 'undefined'){
      if(!isDevelopment){
        openAddNodeForm({
          node: pedigreeParentNodeId,
          relationShip: ( pedigreeGhostMale ? 'father': 'mother')
        });
      }
      else{
        alert('You are on development')
        // console.log(`window.openAddNode(${ pr_id }, '${ choice }', ${ marriageId })`);
      }
      return;
    }

    onClickedFullName({prId:pr_id, node: n});
  }

  touchStart(){
    const {
      stopStageClickPropagation,
      userTouchedNode,
      onClickedFullName,
      pr_id,
      n,
      nodeObj,
      setNodeForFlipFocus,
      setShowMobileFlipCard,
      pedigreeGhostAddLabel,
      openAddNodeForm,
      pedigreeGhostMale,
      pedigreeParentNodeId,
      storePrIdToLocationHistory,
      setFlipCardScreenIsOn,
      nodeObjs,
      showDualPedigreeModalChangeName
    } = this.props;

    if( dualPedigreeMode ){
      showDualPedigreeModalChangeName({node:n, whichField: 'profileName'});
      return;
    }

    stopStageClickPropagation({fromWhere: 'FullNameComponent'});

    userTouchedNode({
      node:n,
      callback: ()=>{
        if(isMobileTablet()){

          if(typeof(pedigreeGhostAddLabel) !== 'undefined'){
            if(!isDevelopment){

              openAddNodeForm({
                node: pedigreeParentNodeId,
                pedigreeGhostAddLabel,
                relationShip: ( pedigreeGhostMale ? 'father': 'mother')
              });
            }
            else{
              alert('You are on development')
              // console.log(`window.openAddNode(${ pr_id }, '${ choice }', ${ marriageId })`);
            }
            return;
          }

          if( parseInt(n, 10) > 0) onClickedFullName({prId:pr_id, node: n});

        }

        if(isMobilePhone() ){

          let screenIsOn = `mainFromHome`;
          if(this.isPedigreeGhost()) {
            screenIsOn = `addFormFromGhost`;
          } else {
            storePrIdToLocationHistory({userExitsFlipCard: false, prId: nodeObj.prId})
          }

          if(this.isPedigreeGhost() || n > 0){
            setFlipCardScreenIsOn({screenIsOn});
            setNodeForFlipFocus(n);
            setShowMobileFlipCard(n);
          }

          if(this.isPedigreeGhost()) {

            if(!isDevelopment){

              setTimeout(() => {
                  let choice = ( pedigreeGhostMale ? 'father' : 'mother');
                  let pr_id = nodeObjs[nodeObj.pedigreeParentNodeId].prId;
                  window.openAddNode(pr_id, choice);
              }, 700);

            }

          }

        };
      },
      fromWhere:'fullname'
    });
  }

  mouseOver(){
    if( dualPedigreeMode ) this.props.cursorBecomesPointer();
    this.props.hideMatchBubble();
  }

  mouseEnter(){
    if( dualPedigreeMode ) this.props.cursorBecomesMove();
    const {canShowHyperlinkOut, nvp, cursorBecomesPointer} = this.props;
    if(!canShowHyperlinkOut(nvp))  return;
    cursorBecomesPointer();
    if( this.isHyperLinkActive() ) this.hovering(true);
  }

  mouseLeave(){
    if( dualPedigreeMode ) return;
    const {canShowHyperlinkOut, nvp, cursorBecomesMove} = this.props;
    if(!canShowHyperlinkOut(nvp)) return;
    cursorBecomesMove();
    if( this.isHyperLinkActive() ) this.hovering(false);
  }

  render() {

    if(dualPedigreeMode && this.props.shouldHideChildrenForDualPedigree({nodeObj: this.props.nodeObj})) return null;

    let {
      side,
      idp,
      n,
      left,
      top,
      nm,
      isPedigree,
      // fn,
      pedigreeGhostAddLabel,
      // pedigreeGhostFemale,
      pedigreeGhostMale,
      pedigreeIsTall,
      pedigreeParentNodeId,
      nodeObjs,
      fontSizeChoice,
      isGGP,
      isChildrenOfDualPedFocusUnion,
      dualPedigreeFontFamily,
      downloadingPedigreeChart,
    } = this.props;

    if( n === '70'){
      // console.log(`left: `, left);
    }

    const isAddLabelPedigreeTall = typeof(pedigreeGhostAddLabel) !== 'undefined' && pedigreeIsTall;
    const isAddLabelPedigreeShort = typeof(pedigreeGhostAddLabel) !== 'undefined' && !pedigreeIsTall;
    const isPedigreeNameLabelTall = typeof(pedigreeGhostAddLabel) === 'undefined' && pedigreeIsTall;
    const isPedigreeNameLabelShort = typeof(pedigreeGhostAddLabel) === 'undefined' && !pedigreeIsTall;

    let pedigreeLeft = 0;
    let pedigreeTall = 0;

    if(isAddLabelPedigreeTall){
      pedigreeLeft = 35;
      pedigreeTall = 2;
    }

    if(isAddLabelPedigreeShort){
      pedigreeLeft = 35;
      pedigreeTall = -1;
    }

    if(isPedigreeNameLabelShort && !dualPedigreeMode){
      pedigreeLeft = 30;
      pedigreeTall = -1;
    }

    if(isPedigreeNameLabelTall && !dualPedigreeMode){
      pedigreeLeft = 36;
      pedigreeTall = -1;
    }

    const seeLeft = left;
    const seeTop = top;

    left += (!isPedigree ? 30: pedigreeLeft);
    top += (!isPedigree ? 1: pedigreeTall);

    if ( dualPedigreeMode && typeof(isChildrenOfDualPedFocusUnion) !== 'undefined' ){// bookmarkPleaseRemove EachLineFullName

      left += 80;
      top -= 26;

    }

    const shiftDown = 10;
    if ( dualPedigreeMode && !isGGP ) top += 39 + shiftDown;
    if ( dualPedigreeMode && isGGP ) top += 36 + shiftDown;
    if ( dualPedigreeMode && isGGP && side === 'right' ) left += 10
    if ( dualPedigreeMode && isGGP && side === 'left' ) left -= 10

    let y = ( isAndroidPhone() ? top + .75 : top);

    if( typeof(this.props.fontSizeChoice) !== 'undefined' && this.props.fontSizeChoice === 'large' ) y += 1.5;

    let labelText = undefined;
    if (isPedigree && (typeof(pedigreeGhostAddLabel) !== 'undefined' && !dualPedigreeMode)
     ) {
      let whichParent = ( pedigreeGhostMale ? 'father': 'mother')
      if(downloadingPedigreeChart) whichParent = capitalizeFirstLetter(whichParent);
      labelText = `${(downloadingPedigreeChart ? '': 'Add')} ${whichParent}`;
      if(typeof(nodeObjs[pedigreeParentNodeId].a) === 'undefined') labelText = '';
    }  else {
      labelText = nm;
    }

    let fullNameText = labelText

    if(urlGet('nodeIs') === "n") fullNameText = `${labelText} (${n})`;
    if(urlGet('nodeIs') === "idp") fullNameText = `${labelText}${( typeof(idp) !== 'undefined' ) ? ' - ' + idp: ''}`;
    if(urlGet('nodeIs') === "prId") fullNameText = `${this.props.pr_id}`;
    if(urlGet('nodeIs') === "pid") fullNameText = `${this.props.pid}`;
    if(urlGet('nodeIs') === "left") fullNameText = `(${n}) ${seeLeft}`;
    if(urlGet('nodeIs') === "both") fullNameText = `${seeLeft}-${seeTop}`;

    let lineHeight = fullNameLineHeight;
    if(typeof(this.props.fontSizeChoice) !== 'undefined' && this.props.fontSizeChoice === 'default'){
      lineHeight = fullNameLineHeight;
    } else if(typeof(this.props.fontSizeChoice) !== 'undefined' && this.props.fontSizeChoice === 'large'){
      lineHeight = fullNameLargeFontLineHeight;
    }

    let fontSize = fontSizeChoice === 'default' ? fullNameFontSize: fullNameLargeFontSize;
    if ( dualPedigreeMode ) fontSize = fullNameLargeFontSize;

    /*
      // Book : adapt position of dualped name
     */

    if ( dualPedigreeMode && typeof(isChildrenOfDualPedFocusUnion) === 'undefined' ) {

      const fullNameTextWidth = getWidthKonvaText({
        str: fullNameText,
        fontSize: fullNameFontSize,
        fontFamily,
        fontStyle: fullNameFontStyle,
        fontWeight: fullNameFontWeight,
        lineHeight: fullNameLineHeight
      })

      const midpointX = left + 40;

      left = midpointX - ( fullNameTextWidth / 2 );
      top -= 4;

      top = widenGreatGrandParentsForDualPedigree({top, idp});

      if( idp ===  1 ){ // Couple

        left = shiftForUnionRoot({side, left})

        if( side === 'left'){

          left += 4;

        }

        if( side === 'right'){

          left += 5;

        }

      } else {

        if( side === 'left'){

          left -= spanOutDualPedigreeProfilessBy - 4;

        }

        if( side === 'right'){

          left += spanOutDualPedigreeProfilessBy + 5;

        }

      }

      y = top;

    }

    if( n === '70'){
      // console.log(`left: `, left);
      // console.log(`side: `, side);
    }

    return <Text
      text={fullNameText}
      // text={`${labelText}-(${n})`}
      // text={`${n} - ${this.props.pr_id}`}
      // text={idp}
      // text={`${nm.substring(0, 10)}  - ${idp}`}
      // text={`${(left - spanOutDualPedigreeProfilessBy + 12)}, ${(top - 4)}`}
      // text={`${(top - 4 + 50)}`}
      // text={`${nm} - ${this.props.n}`}
      // text={`${this.props.n}`}
      // text={`${nm}  - ${scaleX}`}
      // text={`${this.props.pid}`}
      y={y}
      x={left}
      width='auto'
      height={6}
      fontSize={fontSize}
      fontFamily={dualPedigreeMode  ?  dualPedigreeFontFamily: fontFamily}
      fontStyle={fullNameFontStyle}
      fontWeight={fullNameFontWeight}
      lineHeight={lineHeight}
      fill={fullNameFontColor}
      textDecoration={this.state.hovering ? 'underline' : null}
      onTouchStart={this.touchStart.bind(this)}
      onMouseover={this.mouseOver.bind(this)}
      onClick={this.onClick.bind(this)}
      onMouseenter={this.mouseEnter.bind(this)}
      onMouseleave={this.mouseLeave.bind(this)}
    />;
  }
}


export default ({
      n,
      focus,
      idp,
      pr_id,
      pid,
      left,
      top,
      origTop,
      nm,
      g_e,
      fn,
      ln,
      cursorBecomesMove,
      cursorBecomesPointer,
      userTouchedNode,
      stopStageClickPropagation,
      hideMatchBubble,
      onClickedFullName,
      onClickedNode,
      setNodeForFlipFocus,
      setShowMobileFlipCard,
      canShowHyperlinkOut,
      showDualPedigreeModalChangeName,
      nvp,
      scaleX,
      fullNameLineArr,
      isPedigree,
      pedigreeGhostAddLabel,
      pedigreeGhostFemale,
      pedigreeGhostMale,
      openAddNodeForm,
      pedigreeParentNodeId,
      pedigreeIsTall,
      isChildrenOfDualPedFocusUnion,
      nodeObj,
      nodeObjs,
      storePrIdToLocationHistory,
      setFlipCardScreenIsOn,
      fontSizeChoice,
      fullnameArrBasedOnFontSize,
      needEmail,
      isGGP,
      dualPedigreeObj,
      shouldHideChildrenForDualPedigree,
      isSingleChildForDualPedigree,
      side,
      downloadingPedigreeChart,
      buildRefObj,
      callRefObj,
    }) => {

  if(typeof(nm) === 'undefined') {
    return [];
  }

  left -= ( isPedigree ?  15: 0);
  top += ( isPedigree ?  2: 0);
  top += ( typeof(pedigreeGhostAddLabel) !== 'undefined' ? 3: 0);
  const dualPedigreeFontFamily = dualPedigreeObj.fontFamily;

  if(dualPedigreeMode){

    if(isSingleChildForDualPedigree({nodeObj})) {
      top = nodeObj.singleChildTop - 5;
    }

    if(isSingleChildForDualPedigree({nodeObj}) && nodeObj.oneOfTooMany) {
      left += 20;
    }

    if( dualPedigreeObj.whichChildrenNode ===  -1 && typeof(origTop) !== 'undefined' ) top = origTop + 12;

  }

  let props = {
      n,
      focus,
      idp,
      pid,
      pr_id,
      left,
      top,
      nm,
      g_e,
      cursorBecomesMove,
      cursorBecomesPointer,
      userTouchedNode,
      stopStageClickPropagation,
      hideMatchBubble,
      onClickedFullName,
      onClickedNode,
      setNodeForFlipFocus,
      setShowMobileFlipCard,
      canShowHyperlinkOut,
      showDualPedigreeModalChangeName,
      nvp,
      scaleX,
      fullNameLineArr,
      isPedigree,
      pedigreeGhostAddLabel,
      pedigreeGhostFemale,
      pedigreeGhostMale,
      openAddNodeForm,
      pedigreeParentNodeId,
      pedigreeIsTall,
      isChildrenOfDualPedFocusUnion,
      nodeObj,
      nodeObjs,
      storePrIdToLocationHistory,
      setFlipCardScreenIsOn,
      fontSizeChoice,
      needEmail,
      isGGP,
      dualPedigreeFontFamily,
      side,
      dualPedigreeObj,
      shouldHideChildrenForDualPedigree,
      isSingleChildForDualPedigree,
      downloadingPedigreeChart,
      buildRefObj,
      callRefObj,
    };


  let clonedFullNameLineArr = cloneDeep(fullNameLineArr);

  const nextRow = 6;
  let maxWidth = 0;
  let lineLength = 0;
  // console.log(`n: `, n);

  // console.log(`fullNameLineArr: `, JSON.stringify(fullNameLineArr, null, 2));

  const needsEmail = () => {
    return typeof(g_e) !== 'undefined' &&
    parseInt(g_e, 10) === 1
  }

  const isFocus = () => {
    return typeof(focus) !== 'undefined'
  }

  const getWidth = ( line ) => {
    return getWidthKonvaText({
      str: line,
      fontSize: fullNameFontSize,
      fontFamily,
      fontStyle: fullNameFontStyle,
      lineHeight: fullNameLineHeight})
  }

  /*
   *
   *
    Pedigree
   *
   */

  if( isPedigree ){

    if( clonedFullNameLineArr.length > 2 &&
      !isFocus() &&
      needsEmail()
    ){
      clonedFullNameLineArr = clonedFullNameLineArr.slice(0, 2)
    }

    if( pedigreeIsTall ){

      maxWidth = ( fontSizeChoice === 'default' ? fullNameLineWidthPedigreeTreeNormalFont: fullNameLineWidthPedigreeTreeLargeFont);
      lineLength = ( fontSizeChoice === 'default' ? 17: 14);

      for( let idx = 0; idx <= 1; idx++){
        if( typeof(clonedFullNameLineArr[idx]) !== 'undefined' &&
            getWidth(clonedFullNameLineArr[idx]) > maxWidth
        ){
          clonedFullNameLineArr[idx] = truncateWord({str:clonedFullNameLineArr[idx], length: lineLength, useWordBoundary: false, fromWhere: 'fullname'})
        }
      }

      maxWidth = ( fontSizeChoice === 'default' ? 38: 34);
      lineLength = ( fontSizeChoice === 'default' ? 12: 11);
      if(typeof(clonedFullNameLineArr[2]) !== 'undefined'  &&
            getWidth(clonedFullNameLineArr[2]) > maxWidth
      ) {
        clonedFullNameLineArr[2] = truncateWord({str:clonedFullNameLineArr[2], length: lineLength, useWordBoundary: false, fromWhere: 'fullname'})
      }

      if(clonedFullNameLineArr.length > 3){
        clonedFullNameLineArr = clonedFullNameLineArr.slice(0, 3)
      }

    }

    if( !pedigreeIsTall ){

      maxWidth = ( fontSizeChoice === 'default' ? fullNameLineWidthPedigreeTreeNormalFont: fullNameLineWidthPedigreeTreeLargeFont);
      lineLength = ( fontSizeChoice === 'default' ? 19: 14);

      if(typeof(clonedFullNameLineArr[0]) !== 'undefined'  &&
            getWidth(clonedFullNameLineArr[0]) > maxWidth
      ) {
        clonedFullNameLineArr[0] = truncateWord({str:clonedFullNameLineArr[0], length: lineLength, useWordBoundary: false, fromWhere: 'fullname'})
      }


      maxWidth = ( fontSizeChoice === 'default' ? 41: 37);
      lineLength = ( fontSizeChoice === 'default' ? 14: 11);

      if(typeof(clonedFullNameLineArr[1]) !== 'undefined'  &&
            getWidth(clonedFullNameLineArr[1]) > maxWidth
      ) {
        clonedFullNameLineArr[1] = truncateWord({str:clonedFullNameLineArr[1], length: lineLength, useWordBoundary: false, fromWhere: 'fullname'})
      }

      if(clonedFullNameLineArr.length > 2){
        clonedFullNameLineArr = clonedFullNameLineArr.slice(0, 2)
      }
    }

  }



  /*
   *
   *
    Default Tree
   *
   */

  if( !isPedigree ){

    clonedFullNameLineArr = fullnameArrBasedOnFontSize;

    if(needEmail){
      clonedFullNameLineArr = clonedFullNameLineArr.slice(0, 3)
    }

  }

  if( typeof(nodeObjs[n].dualPedigreeCustom) !== 'undefined' &&
      typeof(nodeObjs[n].dualPedigreeCustom.profileName) !== 'undefined'
    ){
    const profileName = nodeObjs[n].dualPedigreeCustom.profileName;
    const width = getPropFromObjInArray({arr: fontArray, searchkey: fontFamily, key: 'name', value: 'width'})
    const { fullNameLineArr }  = buildNameLineArray({nm: profileName, n, width})
    clonedFullNameLineArr = fullNameLineArr;
  }

  const idxRows = clonedFullNameLineArr.length - 1;

  if( dualPedigreeMode && n !== null && parseInt(n, 10) < 0 ) return [];

  return clonedFullNameLineArr.map((lineStr, idx)=>{
    const ref = `fullname_n-${n}-${idx}`;
    return <EachLineFullName
            refName={ref}
            key={`${idx}-${n}`}
            idx={idx}
            { ...{
              ...props,
              top: (top + (idx * nextRow)),
              nm: lineStr,
              idxRows,
              idp,
            }
        }
          />;
  });

};

